module.exports = __webpack_public_path__ + "static/media/4.498b821b.jpg";